import { Redirect, Route, Router, Switch } from './reactRouterDom';
import Loader from '@reportdev-datalake/core-lib/components/Loader';
import PageLoader from '@reportdev-datalake/ui-lib/base/loader/PageLoader';
import Logout from '@/containers/Auth/Logout';

const Admin = Loader({
  loader: () => import('./admin'),
  fallback: PageLoader,
});

const Auth = Loader({
  loader: () => import('./auth'),
  fallback: PageLoader,
});

function App() {
  return (
    <Router>
      <>
        <Switch>
          <Route exact path="/">
            <Redirect to="/admin" />
          </Route>
          <Route exact path="/admin/signout" component={Logout} />
          <Route path="/auth" component={Auth} />
          <Route path="/admin" component={Admin} />
        </Switch>
      </>
    </Router>
  );
}

export default App;
